<template>
  <NuxtLink
    :to="data.event_link"
    target="_blank"
    class="group flex w-full flex-col gap-3 border-b border-primary-blue-gray-light py-4 transition-colors hover:bg-primary-blue-gray-light sm:flex-row sm:items-center sm:gap-6 sm:px-4"
  >
    <!-- DATE -->
    <div class="shrink-0 font-medium text-primary-blue sm:w-32">
      {{ formatDate }}
    </div>

    <!-- TITLE + ORGANIZER -->
    <div class="min-w-0 flex-1">
      <p class="font-semibold text-black group-hover:text-primary-blue">
        {{ data.title }}
      </p>
      <p v-if="data.event_organizer?.title" class="text-sm text-gray-500">
        {{ data.event_organizer.title }}
      </p>
    </div>

    <!-- LOCATION -->
    <div v-if="data.location || data.online" class="shrink-0 text-sm text-gray-600 sm:w-36">
      {{ location }}
    </div>

    <!-- TYPE -->
    <div v-if="data.event_type?.title" class="shrink-0">
      <span class="rounded border-2 border-primary-red bg-primary-red px-2 py-1 text-xs font-semibold uppercase text-white">
        {{ data.event_type.title }}
      </span>
    </div>
  </NuxtLink>
</template>

<script>
import { store } from '/store.js'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  setup() {
    const { locale } = useI18n()
    return { locale }
  },

  computed: {
    translations() {
      return store.translations
    },

    location() {
      if (this.data.location && this.data.online) {
        return `${this.data.location} & ${this.translations.event_online}`
      }
      if (!this.data.location && this.data.online) {
        return this.translations.event_online
      }
      return this.data.location
    },

    formatDate() {
      if (!this.data.date) return ''
      const start = new Date(this.data.date).toLocaleDateString(this.locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      if (!this.data.date_end) return start
      const end = new Date(this.data.date_end).toLocaleDateString(this.locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      return `${start} – ${end}`
    },
  },
}
</script>
